import { render, staticRenderFns } from "./ServicesPage1.vue?vue&type=template&id=673b26d0&scoped=true&"
import script from "./ServicesPage1.vue?vue&type=script&lang=js&"
export * from "./ServicesPage1.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPage1.vue?vue&type=style&index=0&id=673b26d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b26d0",
  null
  
)

export default component.exports